module.exports = __webpack_public_path__ + "img/stratops-notext.de71c5a5.png";